// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/*swiper滚动*/
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(vueSwiper)

/*复制内容到剪切板*/
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/*ElementUI*/
Vue.use(ElementUI)

// 将接口访问方法绑定到全局
import netGo from '@/utils/NetGo'
Vue.prototype.$netGo = netGo
//设置基础参数
import C from '@/utils/C'
Vue.prototype.$C = C

///加载jquery
// import 'jquery'
Vue.config.productionTip = false

// 忽略自定义元素标签抛出的报错
Vue.config.ignoredElements = [
  'wx-open-launch-app',
];
/*百度统计   ---- start*/
var _hmt = _hmt || [];
// 必须把_hmt挂载到window下，否则找不到（很多网友说需要添加我没加也成功了）
window._hmt = _hmt;
(function () {
  var hm = document.createElement("script")
  hm.src = "https://hm.baidu.com/hm.js?e4b5c5269c4155796d5942192bd93fb1"
  var s = document.getElementsByTagName("script")[0]
  s.parentNode.insertBefore(hm, s)
})();

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', to.fullPath]);
    }
  }
  next();
});
/*百度统计   ---- end*/


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js